module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-tabs', {
    staticClass: "tab-nav",
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "全部"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "等待审核"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "审核成功"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "审核失败"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "预审核"
    }
  }), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.goDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "justify-space-flex row-title"
    }, [_c('div', {
      staticClass: "title-left flex-start gray"
    }, [_c('img', {
      staticClass: "row-title-img",
      attrs: {
        "src": "https://static.dierqudao.com/images/dinghuoxitong/icon-date.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("timeFormat")(order.create_time)) + " 申请")])]), _vm._v(" "), _c('div', [(order.kaoji_jindu) ? _c('div', [_c('van-tag', {
      attrs: {
        "plain": ""
      }
    }, [_vm._v(_vm._s(_vm._f("jinduFilter")(order.kaoji_jindu)))])], 1) : _vm._e(), _vm._v(" "), (order.kaojiregist_status == 1) ? _c('van-tag', {
      attrs: {
        "type": "danger",
        "plain": ""
      }
    }, [_vm._v("等待审核")]) : (order.kaojiregist_status == 2) ? _c('van-tag', {
      attrs: {
        "type": "success",
        "plain": ""
      }
    }, [_vm._v("审核成功")]) : (order.kaojiregist_status == 3) ? _c('van-tag', {
      attrs: {
        "type": "warning",
        "plain": ""
      }
    }, [_vm._v("审核失败")]) : (order.kaojiregist_status == 4) ? _c('van-tag', {
      attrs: {
        "type": "primary",
        "plain": ""
      }
    }, [_vm._v("预审核")]) : _c('div', [_vm._v("\n                    未提交\n                  ")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "justify-space-flex row-goods"
    }, [_c('div', {
      staticClass: "row-left flex-start"
    }, [_c('div', {
      staticClass: "goods-detail"
    }, [_vm._v(_vm._s(order.danwei) + " "), (order.kaojitype == '考级点') ? _c('van-tag', {
      attrs: {
        "type": "success",
        "round": "",
        "plain": ""
      }
    }, [_vm._v("\n                    考级点\n                  ")]) : _c('van-tag', {
      attrs: {
        "type": "primary",
        "round": "",
        "plain": ""
      }
    }, [_vm._v("\n                      考级中心\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "gray-light"
    }, [_vm._v(_vm._s(order.province) + _vm._s(order.city) + _vm._s(order.county))]), _vm._v(" "), _c('div', {
      staticClass: "mt5"
    }, [_vm._v("授权编号:" + _vm._s(order.kaojiregist_code ? order.kaojiregist_code : '(无)'))]), _vm._v(" "), _c('div', {
      staticClass: "gray-light"
    }, [_vm._v(" 负责人:" + _vm._s(order.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "gray-light"
    }, [_vm._v(" 手机:" + _vm._s(order.phone))])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "row-btn"
    }, [_c('div', {
      staticClass: "look-order"
    }, [_vm._v("查看详情")])])])
  }), 0)], 1)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65b6e6e1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/apps/qcxj/ExameCenterList.vue
// module id = 2451
// module chunks = 0